import { AbstractControl, ValidatorFn } from '@angular/forms';

export function wholeNumberValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    if (control.value === null || control.value === undefined || control.value === '') return null;
    const num = Number(control.value);
    return Number.isInteger(num) ? null : { wholeNumber: true };
  };
}
